/**
 * 用户认证弹窗系统 JavaScript
 * 仿Anker风格的交互逻辑
 */
console.log('[SSO] JS file loaded at:', new Date().toISOString());
class UserAuthModals {
  constructor() {
    this.isInitialized = false;
    this.activeModal = null;
    this.hoverTimeout = null;

    // 移动端检测
    this.isMobile = this.detectMobile();
    this.mobileMenuVisible = false;

    // Token预加载机制
    this.preloadedToken = null;
    this.tokenExpiry = null;
    this.customerInfo = null;

    // iframe 尺寸管理
    this.originalModalSize = {
      width: '520px',
      height: '650px'
    };
    this.cachedIframeHeights = {
      login: null,
      register: null
    };

    // DOM元素引用
    this.elements = {
      accountIcon: null,
      hoverMenu: null,
      loginModal: null,
      registerModal: null
    };

    this.init();
  }

  // 移动端检测
  detectMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const mobileViewport = window.innerWidth < 768;
    const isMobile = mobileUA || mobileViewport;
    
    console.log('[SSO Debug] detectMobile:', {
      userAgent: userAgent.substring(0, 50) + '...',
      mobileUA,
      mobileViewport,
      innerWidth: window.innerWidth,
      isMobile
    });
    
    return isMobile;
  }
  
  init() {
    if (this.isInitialized) return;
    
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }
  
  setup() {
    console.log('[SSO] setup() called at:', new Date().toISOString());
    this.findElements();
    this.bindEvents();
    this.bindAdditionalEvents();
    this.initializeDisplay();
    this.setupIframes();
    this.setupIframeResizeListener();
    this.checkLoginState();
    this.isInitialized = true;
    console.log('[SSO] setup() finished at:', new Date().toISOString());
  }
  
  initializeDisplay() {
    // 立即激活 hover 菜单，不等待 CSS 检测
    if (this.elements.hoverMenu) {
      // 移除内联的 !important 样式，让 CSS 类接管
      this.elements.hoverMenu.style.removeProperty('display');
      this.elements.hoverMenu.classList.add('ready');
      console.log('[SSO Debug] initializeDisplay: menu initialized, ready class added');
      // 初始化时就设置好位置，避免第一次 hover 时的飞行动画
      this.updateHoverMenuPosition();
    } else {
      console.log('[SSO Debug] initializeDisplay: hoverMenu element not found!');
    }
  }
  
  findElements() {
    // 分别查找桌面端和移动端的登录按钮
    // 桌面端：.login_btn 但不包含 .search_btn_mobile
    const allLoginBtns = document.querySelectorAll('.login_btn');
    this.elements.desktopLoginBtn = null;
    this.elements.mobileLoginBtn = null;    
    allLoginBtns.forEach(btn => {
      if (btn.classList.contains('search_btn_mobile')) {
        this.elements.mobileLoginBtn = btn;
      } else {
        this.elements.desktopLoginBtn = btn;
      }
    });
    
    // 根据设备类型设置主按钮
    this.elements.accountIcon = this.isMobile 
      ? (this.elements.mobileLoginBtn || this.elements.desktopLoginBtn)
      : (this.elements.desktopLoginBtn || this.elements.mobileLoginBtn);
    
    this.elements.hoverMenu = document.getElementById('authHoverMenu');
    this.elements.loginModal = document.getElementById('loginModal');
    this.elements.registerModal = document.getElementById('registerModal');
    this.elements.loginIframe = document.getElementById('loginIframe');
    this.elements.registerIframe = document.getElementById('registerIframe');
    this.elements.drawerLoginLink = document.querySelector('[data-drawer-login-link]');
    
    console.log('[SSO Debug] findElements:', {
      desktopLoginBtn: !!this.elements.desktopLoginBtn,
      mobileLoginBtn: !!this.elements.mobileLoginBtn,
      accountIcon: !!this.elements.accountIcon,
      hoverMenu: !!this.elements.hoverMenu,
      loginModal: !!this.elements.loginModal,
      registerModal: !!this.elements.registerModal,
      isMobile: this.isMobile
    });
  }

  bindEvents() {
    if (!this.elements.accountIcon) {
      console.log('[SSO Debug] bindEvents: accountIcon not found!');
      return;
    }
    console.log('[SSO Debug] bindEvents: binding events, isMobile:', this.isMobile);

    if (this.isMobile) {
      // 移动端：同时监听 click 和 touchstart 事件
      const mobileClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('[SSO Debug] Mobile click handler triggered on:', e.currentTarget.className);
        this.toggleMobileMenu();
        return false;
      };

      // 只为移动端按钮绑定事件

      /*
      if (this.elements.mobileLoginBtn) {
        console.log('[SSO Debug] Binding mobile events to mobile login button');
        this.elements.mobileLoginBtn.addEventListener('click', mobileClickHandler, { capture: true });
        this.elements.mobileLoginBtn.addEventListener('touchstart', mobileClickHandler, { capture: true, passive: false });
      } else if (this.elements.accountIcon) {
        // 后备方案：如果没找到移动端专用按钮，使用主按钮
        console.log('[SSO Debug] Fallback: Binding mobile events to account icon');
        this.elements.accountIcon.addEventListener('click', mobileClickHandler, { capture: true });
        this.elements.accountIcon.addEventListener('touchstart', mobileClickHandler, { capture: true, passive: false });
      }
      */
      // 点击页面其他地方关闭菜单
      document.addEventListener('click', (e) => {
        // 检查是否点击了移动端登录按钮
        const isMobileLoginBtn = this.elements.mobileLoginBtn && this.elements.mobileLoginBtn.contains(e.target);
        
        if (this.mobileMenuVisible &&
            !isMobileLoginBtn &&
            this.elements.hoverMenu &&
            !this.elements.hoverMenu.contains(e.target)) {
          console.log('[SSO Debug] Click outside menu, hiding mobile menu');
          this.hideMobileMenu();
        }
      });
    } else {
      // 桌面端：阻止点击跳转，使用 hover 显示菜单
      const desktopClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('[SSO Debug] Desktop click handler triggered (prevented)');
        return false;
      };

      //只为桌面端按钮绑定事件（移动端已经在上方注释，并在下方写了新的touch事件）
      if (this.elements.desktopLoginBtn) {
        console.log('[SSO Debug] Binding desktop events to desktop login button');
        this.elements.desktopLoginBtn.addEventListener('click', desktopClickHandler, { capture: true });

        this.elements.desktopLoginBtn.addEventListener('mouseenter', () => {
          this.showHoverMenu();
        });
        this.elements.desktopLoginBtn.addEventListener('mouseleave', () => {
          this.hideHoverMenu();
        });
      } else if (this.elements.accountIcon) {
        // 后备方案
        console.log('[SSO Debug] Fallback: Binding desktop events to account icon');
        this.elements.accountIcon.addEventListener('click', desktopClickHandler, { capture: true });
        this.elements.accountIcon.addEventListener('mouseenter', () => {
          this.showHoverMenu();
        });
        this.elements.accountIcon.addEventListener('mouseleave', () => {
          this.hideHoverMenu();
        });
      }

      if (this.elements.hoverMenu) {
        this.elements.hoverMenu.addEventListener('mouseenter', () => {
          this.showHoverMenu();
        });
        this.elements.hoverMenu.addEventListener('mouseleave', () => {
          this.hideHoverMenu();
        });
      }
    }

    // 移动端抽屉菜单的登录链接
    if (this.elements.drawerLoginLink) {
      const drawerClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        // 显示菜单让用户选择 Login 或 Sign up
        this.toggleMobileMenu();
        return false;
      };

      this.elements.drawerLoginLink.addEventListener('click', drawerClickHandler, { capture: true });
      this.elements.drawerLoginLink.addEventListener('touchstart', drawerClickHandler, { capture: true, passive: false });
    }

    // 菜单内按钮点击事件（移动端和桌面端共用） ----------------移动端哪来的hover事件？？？？？？pues agregar nota abajo dos lineas aqui 
    //if (this.elements.hoverMenu) {}
    //this.elements.hoverMenu.addEventListener('click', (e) => { });
    
    if(/(iphone | android | mobild)/i.test(navigator.userAgent)){ //手机单独不需要票窗菜单登录
      var modalType = document.querySelectorAll("button[data-modal='login']")[0];
      this.checkShopifyLoginState().then(loginState=>{
        if(loginState.isLoggedIn){  //已经登录的点击行为
          if(modalType){
            modalType.addEventListener('touchstart',(e)=>{
              e.preventDefault();
              this.showHoverMenu();
                document.addEventListener('touchstart',(ee)=>{
                  ee.preventDefault();
                  ee.stopImmediatePropagation();
                  ee.stopPropagation();
                  if(ee.target.nodeName !== 'IMG'){
                    this.hideHoverMenu();
                  }
                })
            });
          }
        }else{  //未登录的点击行为
           if (modalType) {
            modalType.addEventListener('touchstart',(e)=>{
              e.preventDefault();
                //this.openModal('login'); //若要同PC一样的方案，弹出窗口内嵌入iframe，放开此处注释，并注释下方⬇️
                var iframe = document.createElement('iframe');
                iframe.id="loginIframe";
                iframe.class="class";
                iframe.src="2https://test-account.ugreen.com/index/user/login.html?sso_origin={{ 'https://' | append: request.host | url_encode }}&client_id=shopify_sso&shop=BR"
                iframe.title="登录页面"
                iframe.sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                iframe.style.background='transparent';
                iframe.style.setProperty('position','fixed');
                iframe.style.setProperty('top','0');
                iframe.style.setProperty('left','0');
                iframe.style.setProperty('z-index','9999999');
                iframe.style.setProperty('width','100%');
                iframe.style.setProperty('height','100%');
                document.body.appendChild(iframe);
            });
          }
        }
      })
       
    }else{
    if (this.elements.hoverMenu) {
      this.elements.hoverMenu.addEventListener('click', (e) => {
          var modalType = e.target.getAttribute('data-modal');
        if (modalType) {
          e.preventDefault();
          if (this.isMobile) {
            // 移动端：直接跳转到 PHP 登录页
            this.redirectToPhpAuth(modalType);
            // this.openModal(modalType);
            // this.hideHoverMenu();
          } else {
            // 桌面端：打开 iframe 模态框 
            console.log('modalType'+modalType)           
            this.openModal(modalType);
            this.hideHoverMenu();
          }
        }
      });
    }
    }
    /*
        const modalType = e.target.getAttribute('data-modal');
        if (modalType) {
          e.preventDefault();
          if (this.isMobile) {
            // 移动端：直接跳转到 PHP 登录页
            this.redirectToPhpAuth(modalType);
            // this.openModal(modalType);
            // this.hideHoverMenu();
          } else {
            // 桌面端：打开 iframe 模态框
            this.openModal(modalType);
            this.hideHoverMenu();
          }
        }
     */
    
    
    // 监听来自iframe的postMessage
    window.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'auth-action') {
        if (event.origin !== 'https://test-account.ugreen.com') {
          return;
        }
        this.handleAuthMessage(event.data);
      }

      if (event.data && event.data.type === 'php_debug') {
        if (event.origin !== 'https://test-account.ugreen.com') {
          return;
        }
        return;
      }

      if (event.data && event.data.type === 'PHP_DEBUG_INFO') {
        return;
      }

      if (event.data && event.data.type === 'LOGIN_MULTIPASS') {
        this.handleLoginSuccess(event.data);
        return;
      }

      if (event.data && event.data.type === 'login-success') {
        if (event.origin !== 'https://test-account.ugreen.com') {
          return;
        }
        this.handleLoginSuccess(event.data);
      }
    });
  }
  //在移动端登录头像可点击
  clickAbleAtMobileOnUserAvt() {
      var accountIcon = this.elements.accountIcon;
      accountIcon.href="javascript:void(0);";
      var userMenu = this.elements.hoverMenu.querySelector('.auth-menu-card');
      
      accountIcon.onclick=function(){
        console.log('%cClick Event','font-size:33px;')
      }
      
  }
  
  handleAuthMessage(data) {

    console.log('%cLogin Message Panel Appear----','font-size:33px;')

    const { action } = data;

    switch (action) {
      case 'login':
        this.openModal('login');
        this.hideHoverMenu();
        break;
      case 'register':
        this.openModal('register');
        this.hideHoverMenu();
        break;
    }
  }

  handleLoginSuccess(data) {
    if (data.type === 'LOGIN_MULTIPASS' && data.multipassUrl) {
      if (data.userData) {
        localStorage.setItem('userInfo', JSON.stringify(data.userData));
        localStorage.setItem('isLoggedIn', 'true');
      }
      if (this.activeModal) {
        this.closeModal();
      }
      window.location.href = data.multipassUrl;
      return;
    }

    const { userData } = data;
    localStorage.setItem('userInfo', JSON.stringify(userData));
    localStorage.setItem('isLoggedIn', 'true');

    if (this.activeModal) {
      this.closeModal();
    }

    this.updateHoverMenuToLoggedIn();
  }

  // 更新hover菜单为已登录状态
  async updateHoverMenuToLoggedIn(customerInfo = null) {
    if (!this.elements.hoverMenu) return;

    if (customerInfo) {
      this.customerInfo = customerInfo;
    }
    const menuCard = this.elements.hoverMenu.querySelector('.auth-menu-card');

    

    if (menuCard) {
      const displayName = customerInfo ?
        `${customerInfo.first_name || ''} ${customerInfo.last_name || ''}`.trim() || customerInfo.email :
        'User';

      const profileIcon = document.querySelector("input#profile_icon[type='hidden']").value;
      const orderIcon = document.querySelector("input#order_icon[type='hidden']").value;
      const logoutIcon = document.querySelector("input#logout_icon[type='hidden']").value;
      menuCard.innerHTML = `
      <div>
        <div class="user-greeting" title="${displayName}" style="color:#0D0D0D;">Hi, ${displayName}</div>
        <a href="#" class="auth-link" data-action="profile">
          <span class="link-text" style="display:flex;flex-flow:row nowrap;align-items:center;font-size:14px;font-weight:500;gap:9px;justify-content:flex-start;width:100%;color:#0D0D0D;"><img style="width:14px;" src="${profileIcon}"/>Profile</span>
          <span class="link-loading" style="display:none;">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" style="width:14px;height:14px;vertical-align:middle;margin-right:4px;">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/>
            </svg>
            Loading...
          </span>
        </a>
        <a href="#" class="auth-link" data-action="order">
          <span class="link-text" style="display:flex;flex-flow:row nowrap;align-items:center;font-size:14px;font-weight:500;gap:9px;justify-content:flex-start;width:100%;color:#0D0D0D;"><img style="width:14px;" src="${orderIcon}"/>Orders</span>
          <span class="link-loading" style="display:none;">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" style="width:14px;height:14px;vertical-align:middle;margin-right:4px;">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/>
            </svg>
            Loading...
          </span>
        </a>
        <a href="/account/logout" class="auth-link" data-action="logout">
          <span class="link-text" style="display:flex;flex-flow:row nowrap;align-items:center;font-size:14px;font-weight:500;gap:9px;justify-content:flex-start;width:100%;color:#0D0D0D;"><img style="width:14px;" src="${logoutIcon}"/>Log out</span>
          <span class="link-loading" style="display:none;">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" style="width:14px;height:14px;vertical-align:middle;margin-right:4px;">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/>
            </svg>
            Loading...
          </span>
        </a>
        <a style="height:8px;"></a>
        </div>
      `;
/***
 *  之前的logout样式
 * 
         <a href="/account/logout" class="auth-link" data-action="logout" style="display:flex;flex-flow:row nowrap;align-items:center;font-size:14px;font-weight:500;gap:9px;justify-content:flex-start;width:100%;padding:0;">
          <img style="width:14px;" src="${logoutIcon}"/>
          Log out
        </a>
 * 
 */
      this.bindAuthLinkEvents();
    }

    this.updateUserAvatar(customerInfo);
  }

  async generateAuthToken(customerInfo) {
    try {
      const response = await fetch('https://test-account.ugreen.com/index/sso/generateToken', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Origin': window.location.origin
        },
        body: JSON.stringify({
          email: customerInfo.email,
          shopify_id: customerInfo.id || '',
          site_code: 'BR',
          sso_origin: window.location.origin
        })
      });

      const result = await response.json();
      return result.code === 1 ? result.data.token : null;
    } catch (error) {
      return null;
    }
  }

  async preloadToken() {
    if (this.preloadedToken && this.tokenExpiry && this.tokenExpiry > Date.now() + 60000) {
      return;
    }
    //判断是否登录状态;
    const loginState = await this.checkShopifyLoginState();
    if (loginState.isLoggedIn && loginState.customerInfo) {
      const token = await this.generateAuthToken(loginState.customerInfo);
      if (token) {
        this.preloadedToken = token;
        this.tokenExpiry = Date.now() + 30 * 60 * 1000;
        this.customerInfo = loginState.customerInfo;
      }
    }
  }

  bindAuthLinkEvents() {
    const profileLink = this.elements.hoverMenu.querySelector('[data-action="profile"]');
    const orderLink = this.elements.hoverMenu.querySelector('[data-action="order"]');

    if (profileLink) {
      profileLink.addEventListener('click', (e) => this.handleAuthLinkClick(e, '/index/user/profile.html'));
    }

    if (orderLink) {
      orderLink.addEventListener('click', (e) => this.handleAuthLinkClick(e, '/index/user/order.html'));
    }

    const logoutLink = this.elements.hoverMenu.querySelector('[data-action="logout"]');
    if (logoutLink) {
      logoutLink.addEventListener('click', (e) => this.handleLogoutClick(e));
    }
    /*
    if(/(iphone|android|mobile)/i.test(navigator.userAgent)){
      clickAbleAtMobileOnUserAvt();
    }
    */
  }

  async handleAuthLinkClick(event, redirectPath) {
    event.preventDefault();

    const link = event.currentTarget;
    const linkText = link.querySelector('.link-text');
    const linkLoading = link.querySelector('.link-loading');

    if (linkText) linkText.style.display = 'none';
    if (linkLoading) linkLoading.style.display = 'inline';
    link.style.pointerEvents = 'none';

    const timeout = setTimeout(() => {
      if (linkText) linkText.style.display = 'flex';
      if (linkLoading) linkLoading.style.display = 'none';
      link.style.pointerEvents = '';
      alert('请求超时，请检查网络连接后重试');
    }, 15000);

    try {
      let token = this.preloadedToken;

      if (!token || !this.tokenExpiry || this.tokenExpiry < Date.now()) {
        const loginState = await this.checkShopifyLoginState();
        if (loginState.isLoggedIn && loginState.customerInfo) {
          token = await this.generateAuthToken(loginState.customerInfo);
          if (token) {
            this.preloadedToken = token;
            this.tokenExpiry = Date.now() + 30 * 60 * 1000;
          }
        }
      }

      clearTimeout(timeout);

      if (token) {
        // 使用单次token后立即失效缓存，避免重复使用nonce
        this.preloadedToken = null;
        this.tokenExpiry = null;
        window.open(`https://test-account.ugreen.com/index/sso/auth?sso_token=${token}&redirect=${redirectPath}`, '_blank');
      } else {
        alert('登录状态异常，请重新登录');
      }
    } catch (error) {
      clearTimeout(timeout);
      alert('操作失败，请稍后重试');
    } finally {
      if (linkText) linkText.style.display = 'flex';
      if (linkLoading) linkLoading.style.display = 'none';
      link.style.pointerEvents = '';
    }
  }

  async handleLogoutClick(event) {
    event.preventDefault();

    try {
      await this.syncPhpLogout();
    } catch (error) {
    } finally {
      window.location.href = '/account/logout';
    }
  }

  async syncPhpLogout() {
    const controller = new AbortController();
    const abortTimer = setTimeout(() => controller.abort(), 8000);

    try {
      const response = await fetch('https://test-account.ugreen.com/index/sso/syncLogout', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ timestamp: Date.now() }),
        signal: controller.signal
      });

      clearTimeout(abortTimer);

      if (!response.ok) {
        throw new Error(`syncLogout HTTP ${response.status}`);
      }

      let result = {};
      try {
        result = await response.json();
      } catch (err) {
        result = {};
      }

      await new Promise((resolve) => setTimeout(resolve, 200));
      return result;

    } catch (error) {
      clearTimeout(abortTimer);
      return this.syncPhpLogoutFallback();
    }
  }

  syncPhpLogoutFallback() {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.referrerPolicy = 'no-referrer';
      iframe.src = 'https://test-account.ugreen.com/index/user/logout.html';

      const cleanup = () => {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
        resolve();
      };

      iframe.onload = () => {
        setTimeout(cleanup, 1500);
      };

      iframe.onerror = cleanup;

      document.body.appendChild(iframe);

      setTimeout(cleanup, 5000);
    });
  }

  // 更新用户头像
  updateUserAvatar(customerInfo = null, isLoggedIn = true) {
    // 尝试多个可能的头像选择器
    const selectors = [
      '.login_btn svg',
      '.login_btn img',
      '.header__icon--account img',
      '.header__icon--account svg',
      '.account-icon img',
      'account-icon img',
      'account-icon svg',
      'account-icon',
      '[data-header-icon="account"] img'
    ];

    let avatarElements = [];
    for (const selector of selectors) {
      avatarElements = document.querySelectorAll(selector);
      if (avatarElements.length > 0) break;
    }

    if (avatarElements.length === 0) {
      return;
    }

    let avatarUrl;
    const defaultAvatar = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23999"%3E%3Cpath d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/%3E%3C/svg%3E';
    
    if (isLoggedIn && customerInfo) {
      // 使用 Metafields 中的头像，如果没有则使用默认灰色头像
      console.log('头像1')
      avatarUrl = customerInfo.avatar_url || defaultAvatar;
    } else {
      // 未登录：恢复原始头像
      console.log('头像2')
      avatarUrl = avatarElements[0].getAttribute('data-original-src') || avatarElements[0].src;
    }

    avatarElements.forEach((element, index) => {
      if (element.tagName.toLowerCase() === 'img') {
        // 处理 IMG 元素
        if (isLoggedIn) {
          // 保存原始头像URL以便恢复
          if (!element.getAttribute('data-original-src')) {
            element.setAttribute('data-original-src', element.src);
          }
        }

        element.src = avatarUrl;
        element.alt = customerInfo && isLoggedIn ?
          `${customerInfo.first_name || 'User'} Avatar` :
          'Account';

      } else if (element.tagName.toLowerCase() === 'svg' || element.closest('account-icon')) {
        // 处理 SVG 元素或 account-icon 元素

        if (avatarUrl && avatarUrl !== 'undefined' && isLoggedIn) {
          // 创建新的 IMG 元素来替换 SVG
          const imgElement = document.createElement('img');
          imgElement.src = avatarUrl;
          imgElement.alt = `${customerInfo.first_name || 'User'} Avatar`;
          imgElement.style.width = '24px';
          imgElement.style.height = '24px';
          imgElement.style.borderRadius = '50%';
          imgElement.style.objectFit = 'cover';

          // 保存原始元素以便恢复
          if (!element.getAttribute('data-original-element')) {
            element.setAttribute('data-original-element', 'true');
            element.setAttribute('data-hidden', 'true');
            element.style.display = 'none';
          }

          // 插入新的 IMG 元素
          element.parentNode.insertBefore(imgElement, element);

        } else {
          // 恢复原始 SVG
          const hiddenElement = element.parentNode.querySelector('[data-original-element="true"]');
          if (hiddenElement) {
            hiddenElement.style.display = '';
            hiddenElement.removeAttribute('data-hidden');

            const tempImg = element.parentNode.querySelector('img[alt*="Avatar"]');
            if (tempImg && tempImg !== hiddenElement) {
              tempImg.remove();
            }
          }
        }
      }
    });
  }

  // 更新hover菜单为未登录状态
  updateHoverMenuToLoggedOut() {
    //console.log(`%cUser-Agent:${navigator.userAgent}`,"font-size:30px;");
    if (!this.elements.hoverMenu) return;

    const menuCard = this.elements.hoverMenu.querySelector('.auth-menu-card');
    if (menuCard) {
      console.log(`%cUser-Agent:${navigator.userAgent}`,"font-size:30px;");
      
       if(/(iphone | android)/i.test(navigator.userAgent)){ //手机
        menuCard.innerHTML = `
          <button class="auth-btn auth-btn--login" data-modal="login" type="button">
            Log In
          </button>
          <a href="#" class="auth-link" data-modal="register">
            Sign up
          </a>
        `
      }else{ //移动端展示不实现sheet窗口（点击直接出现登录窗口），以下设置保留，防止摇摆需求
        menuCard.innerHTML = `
        <div style="padding:16px 0px;">
          <button class="auth-btn auth-btn--login" data-modal="login" type="button">
            Log In
          </button>
          <a href="#" class="auth-link" data-modal="register">
            Sign up
          </a>
        </div>
        `
      }
      
      /*
      menuCard.innerHTML = `
          <button class="auth-btn auth-btn--login" data-modal="login" type="button">
            Log In
          </button>
          <a href="#" class="auth-link" data-modal="register">
            Sign up
          </a>
        `
      */
    }

    // 恢复默认头像
    this.updateUserAvatar(null, false);
  }

  // 检查登录状态
  checkLoginState() {
    // 检查 Shopify 实际登录状态
    this.checkShopifyLoginState().then(loginState => {
      if (loginState.isLoggedIn && loginState.customerInfo) {
        console.log('异地登录')
        // 已登录，更新菜单
        this.updateHoverMenuToLoggedIn(loginState.customerInfo);
      } else {
        console.log('异地登录2')
        // 未登录，显示默认菜单
        this.updateHoverMenuToLoggedOut();
      }
    });
  }

  checkShopifyLoginState() {
    // 使用 Liquid 模板设置的全局变量
    const isLoggedIn = window.customerLoggedIn === true;
    const customerInfo = window.customer;
    console.log('准备登录'+isLoggedIn)
    return Promise.resolve({
      isLoggedIn,
      customerInfo
    });
  }
  
  // 补充事件绑定
  bindAdditionalEvents() {
    // 模态框通用事件绑定
    this.bindModalEvents(this.elements.loginModal);
    this.bindModalEvents(this.elements.registerModal);
    
    // 全局ESC键事件
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activeModal) {
        this.closeModal();
      }
    });
    
    // 模态框切换事件
    document.addEventListener('click', (e) => {
      const modalType = e.target.getAttribute('data-modal');
      if (modalType && e.target.classList.contains('auth-form__switch')) {
        e.preventDefault();
        this.openModal(modalType);
      }
    });
  }
  
  bindModalEvents(modal) {
    if (!modal) return;

    // 点击 modal 外部关闭（点击背景区域）
    modal.addEventListener('click', (e) => {
      // 如果点击的是 modal 本身（不是内部的 content），则关闭
      if (e.target === modal || e.target.classList.contains('auth-modal__backdrop')) {
        this.closeModal();
      }
    });

    // 关闭按钮
    const closeBtn = modal.querySelector('.auth-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 防止事件冒泡
        this.closeModal();
      });
    }

    // 返回按钮
    const backBtn = modal.querySelector('.auth-modal__back');
    if (backBtn) {
      backBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeModal();
      });
    }
  }
  
  // 移动端菜单切换
  toggleMobileMenu() {
    console.log('[SSO Debug] toggleMobileMenu called, current state:', this.mobileMenuVisible);
    if (this.mobileMenuVisible) {
      this.hideMobileMenu();
    } else {
      this.showMobileMenu();
    }
  }

  showMobileMenu() {
    console.log('[SSO Debug] showMobileMenu called, hoverMenu exists:', !!this.elements.hoverMenu);
    if (this.elements.hoverMenu) {
      this.elements.hoverMenu.classList.add('show');
      this.mobileMenuVisible = true;
      console.log('[SSO Debug] Mobile menu shown');
    }
  }

  hideMobileMenu() {
    console.log('[SSO Debug] hideMobileMenu called');
    if (this.elements.hoverMenu) {
      this.elements.hoverMenu.classList.remove('show');
      this.mobileMenuVisible = false;
    }
  }

  // 移动端跳转到 PHP 认证页面
  redirectToPhpAuth(type) {
    const phpBaseUrl = 'https://test-account.ugreen.com';
    const returnPath = window.location.pathname + window.location.search;

    const authUrl = type === 'login'
      ? `${phpBaseUrl}/index/user/login.html`
      : `${phpBaseUrl}/index/user/register.html`;

    const params = new URLSearchParams({
      return_path: returnPath,
      client_id: 'shopify_sso'
    });

    window.location.href = `${authUrl}?${params.toString()}`;
  }

  // 更新 hover menu 位置
  updateHoverMenuPosition() {
    if (this.elements.hoverMenu) {
      // 使用对应设备的按钮来计算位置
      const targetBtn = this.isMobile ? this.elements.mobileLoginBtn : this.elements.desktopLoginBtn;
      const iconElement = targetBtn || this.elements.accountIcon;
      
      if (iconElement) {
        const iconRect = iconElement.getBoundingClientRect();
        const menuEl = this.elements.hoverMenu;

        menuEl.style.position = 'fixed';
        menuEl.style.top = (iconRect.bottom + 8) + 'px';
        menuEl.style.right = (window.innerWidth - iconRect.right) + 'px';
        menuEl.style.left = 'auto';
        menuEl.style.transition = 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out';
      }
    }
  }

  // 桌面端 hover 菜单显示
  showHoverMenu() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    if (this.elements.hoverMenu && this.elements.accountIcon) {
      // 先更新位置（无动画）
      this.updateHoverMenuPosition();
      // 再显示（只有透明度动画）
      this.elements.hoverMenu.classList.add('show');
    }

    this.preloadToken();
  }

  hideHoverMenu() {
    this.hoverTimeout = setTimeout(() => {
      if (this.elements.hoverMenu) {
        this.elements.hoverMenu.classList.remove('show');
      }
    }, 100);
  }
  
  openModal(type) {
    // 关闭当前活跃的模态框
    if (this.activeModal) {
      this.closeModal();
    }
    
    let modal;
    if (type === 'login') {
      modal = this.elements.loginModal;
    } else if (type === 'register') {
      modal = this.elements.registerModal;
    }
    
    if (modal) {
      // 重置iframe状态，清除可能的fallback显示
      this.resetIframeState(modal);
      
      this.activeModal = modal;
      modal.style.display = 'block';
      
      // 强制重排，然后添加show类实现动画
      modal.offsetHeight;
      modal.classList.add('show');

      // 强制移除 iframe modal 的所有视觉元素
      const modalContent = modal.querySelector('.auth-modal__content');
      if (modalContent && (modalContent.classList.contains('auth-modal__content--login-iframe') || modalContent.classList.contains('auth-modal__content--register'))) {
        this.prepareModalContentForAnimation(modalContent);

        // 设置 modal content
        modalContent.style.setProperty('background', 'none', 'important');
        modalContent.style.setProperty('box-shadow', 'none', 'important');
        modalContent.style.setProperty('border', 'none', 'important');

        // 设置 modal body
        const body = modalContent.querySelector('.auth-modal__body');
        if (body) {
          body.style.setProperty('background', 'transparent', 'important');
          body.style.setProperty('padding', '0', 'important');
        }

        // 设置 iframe container
        const iframeContainer = modalContent.querySelector('.auth-iframe-container');
        if (iframeContainer) {
          iframeContainer.style.setProperty('background', 'transparent', 'important');
        }

        // 设置 iframe 本身 - 初始完全隐藏，等高度设置好后再显示
        const iframe = modalContent.querySelector('iframe');
        if (iframe) {
          iframe.style.setProperty('background', 'transparent', 'important');

          const cachedHeight = type ? this.cachedIframeHeights[type] : null;
          const defaultHeight = this.getDefaultIframeHeight(type);
          const initialHeight = cachedHeight || defaultHeight;

          if (initialHeight) {
            this.applyIframeHeight(modalContent, initialHeight, {
              makeVisible: true,
              reason: cachedHeight ? 'cache-open' : 'default-open'
            });
          } else {
            // 无缓存或默认高度时保持隐藏，等待 postMessage
            modalContent.style.setProperty('visibility', 'hidden', 'important');
          }

          // 不再需要 load 事件监听，改用 postMessage
        }
      }

      // 防止页面滚动
      document.body.style.overflow = 'hidden';

      // 聚焦到第一个输入框
      const firstInput = modal.querySelector('input[type="email"]');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100);
      }
    }
  }
  
  // 重置iframe状态
  resetIframeState(modal) {
    const iframe = modal.querySelector('.auth-iframe');
    const fallback = modal.querySelector('.auth-iframe-fallback');
    
    if (iframe && fallback) {
      // 确保iframe显示，fallback隐藏
      iframe.style.display = '';
      fallback.style.display = 'none';
    }
  }
  
  closeModal() {
    if (!this.activeModal) return;

    const modal = this.activeModal;

    // 移除show类，触发关闭动画
    modal.classList.remove('show');

    // 动画结束后隐藏模态框
    setTimeout(() => {
      modal.style.display = 'none';

      // 重置iframe状态，防止下次打开时闪现
      const modalContent = modal.querySelector('.auth-modal__content');
      if (modalContent) {
        this.prepareModalContentForAnimation(modalContent);
        modalContent.style.removeProperty('height');
        modalContent.style.removeProperty('top');
      }

      this.activeModal = null;

      // 恢复页面滚动
      document.body.style.overflow = '';
    }, 200); // 与CSS transition时间匹配
  }
  
  // 工具方法：检查是否有活跃的模态框
  hasActiveModal() {
    return this.activeModal !== null;
  }
  
  // 工具方法：获取当前活跃的模态框类型
  getActiveModalType() {
    if (!this.activeModal) return null;

    if (this.activeModal === this.elements.loginModal) return 'login';
    if (this.activeModal === this.elements.registerModal) return 'register';
    return null;
  }

  
  // 设置iframe错误处理
  setupIframes() {
    const iframes = [
      { id: 'loginIframe', fallbackId: 'loginFallback' },
      { id: 'registerIframe', fallbackId: 'registerFallback' }
    ];

    iframes.forEach(({ id, fallbackId }) => {
      const iframe = document.getElementById(id);
      if (iframe) {
        iframe.onload = () => {
          iframe.dataset.loaded = 'true';
        };

        iframe.onerror = () => {
          iframe.dataset.loaded = 'false';
          this.showIframeFallback(iframe, fallbackId);
        };
      }
    });
  }
  
  // 显示iframe失败后的备选方案
  showIframeFallback(iframe, fallbackId) {
    const container = iframe.parentElement;
    const fallback = container.querySelector('.auth-iframe-fallback');

    if (fallback) {
      const fallbackLink = fallback.querySelector('a[href]');
      if (fallbackLink) {
        window.open(fallbackLink.href, '_blank', 'noopener');
      }
    }

    this.closeModal();
  }

  getDefaultIframeHeight(type) {
    if (type === 'register') {
      return 760;
    }
    if (type === 'login') {
      return 560;
    }
    return null;
  }

  prepareModalContentForAnimation(modalContent) {
    if (!modalContent) {
      return;
    }

    modalContent.style.setProperty('visibility', 'hidden', 'important');
    modalContent.dataset.pendingVisible = 'true';
  }

  showModalContent(modalContent) {
    if (!modalContent || modalContent.dataset.pendingVisible !== 'true') {
      return;
    }

    const reveal = () => {
      modalContent.style.setProperty('visibility', 'visible', 'important');
      delete modalContent.dataset.pendingVisible;
    };

    // 双 requestAnimationFrame 确保样式已应用，动画方向一致
    requestAnimationFrame(() => {
      requestAnimationFrame(reveal);
    });
  }

  // 监听 PHP 侧的 iframe 尺寸调整请求
  setupIframeResizeListener() {
    window.addEventListener('message', (event) => {
      // 只接受来自 account 的消息
      if (!event.origin.includes('test-account.ugreen.com')) {
        return;
      }

      const data = event.data;

      // 处理高度调整消息
      if (data.type === 'IFRAME_HEIGHT') {
        if (typeof data.height !== 'number') {
          return;
        }

        const iframeInfo = this.getIframeInfoBySource(event.source);
        if (!iframeInfo) {
          return;
        }

        const { type, modal, modalContent } = iframeInfo;
        this.cachedIframeHeights[type] = data.height;

        if (modalContent) {
          const makeVisible = this.activeModal === modal;
          this.applyIframeHeight(modalContent, data.height, {
            makeVisible,
            reason: data.reason || 'post-message'
          });
        }
        return;
      }

      if (data.type !== 'RESIZE_IFRAME') {
        return;
      }

      const modal = this.activeModal;
      const modalContent = modal?.querySelector('.auth-modal__content');

      if (!modal || !modalContent) {
        return;
      }

      if (data.action === 'expand') {
        const newWidth = data.width + 'px';
        const newHeight = data.height + 'px';

        modalContent.style.transition = 'all 0.3s ease';
        modalContent.style.width = newWidth;
        modalContent.style.height = newHeight;

      } else if (data.action === 'restore') {
        modalContent.style.width = this.originalModalSize.width;
        modalContent.style.height = this.originalModalSize.height;
      }
    });
  }

  getIframeInfoBySource(sourceWindow) {
    if (!sourceWindow) {
      return null;
    }

    const {
      loginIframe,
      registerIframe,
      loginModal,
      registerModal
    } = this.elements;

    if (loginIframe && loginIframe.contentWindow === sourceWindow) {
      return {
        type: 'login',
        modal: loginModal,
        modalContent: loginModal?.querySelector('.auth-modal__content') || null
      };
    }

    if (registerIframe && registerIframe.contentWindow === sourceWindow) {
      return {
        type: 'register',
        modal: registerModal,
        modalContent: registerModal?.querySelector('.auth-modal__content') || null
      };
    }

    return null;
  }

  applyIframeHeight(modalContent, contentHeight, options = {}) {
    if (!modalContent || typeof contentHeight !== 'number') {
      return;
    }

    const { makeVisible = false, reason = 'update' } = options;

    const viewportHeight = window.innerHeight;

    // 动态获取header的真实高度
    const announcementBar = document.querySelector('.shopify-section-sections--20401143415003__announcement-bar, [id*="announcement-bar"]');
    const header = document.querySelector('.shopify-section-sections--20401143415003__header, shopify-section header, [id*="header"]');

    let headerTotalHeight = 0;
    if (announcementBar) {
      headerTotalHeight += announcementBar.offsetHeight;
    }
    if (header) {
      headerTotalHeight += header.offsetHeight;
    }

    if (headerTotalHeight === 0) {
      headerTotalHeight = 100;
    }

    const topMargin = headerTotalHeight + 20; // header高度 + 20px边距
    const bottomMargin = 70; // 底部边距
    const availableHeight = Math.max(viewportHeight - topMargin - bottomMargin, 320);

    const finalHeight = Math.min(contentHeight, availableHeight);

    modalContent.style.setProperty('height', `${finalHeight}px`, 'important');

    // 计算top位置
    let topPosition;
    if (finalHeight < availableHeight) {
      // 垂直居中
      topPosition = topMargin + (availableHeight - finalHeight) / 2;
    } else {
      // 从顶部边距开始
      topPosition = topMargin;
    }

    modalContent.style.setProperty('top', `${topPosition}px`, 'important');
    modalContent.style.setProperty('transform', 'translateX(-50%)', 'important');

    // 强制设置overflow:hidden和圆角，裁剪溢出内容
    modalContent.style.setProperty('overflow', 'hidden', 'important');
    modalContent.style.setProperty('border-radius', '8px', 'important');

    if (makeVisible) {
      this.showModalContent(modalContent);
    }

  }
}

// 全局实例化
window.userAuthModals = null;

// 确保在DOM加载后初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUserAuthModals);
} else {
  initUserAuthModals();
}

function initUserAuthModals() {
  if (!window.userAuthModals) {
    window.userAuthModals = new UserAuthModals();
  }
}

// 导出供其他脚本使用
if (typeof module !== 'undefined' && module.exports) {
  module.exports = UserAuthModals;
}
